//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ChooseOrderGroup from './choose-plan-school/ChooseOrderGroup.vue';
import PlanSchoolCard from './choose-plan-school/PlanSchoolCard.vue';
import SectionIndicators from '../components/ui/SectionIndicators.vue';

export default {
    name: 'ChoosePlanSchool',
    components: {
        ChooseOrderGroup,
        PlanSchoolCard,
        SectionIndicators,
    },
    props: {
        headerInformation: {
            required: true,
            type: Object,
        },
        groupOne: {
            required: true,
            type: Object,
        },
        groupTwo: {
            required: true,
            type: Object,
        },
        groupThree: {
            required: true,
            type: Object,
        },
    },
    data: () => {
        return {
            orderGroup: 'one',
        };
    },
    methods: {
    },
};




// WEBPACK FOOTER //
// ./scripts/vue/template-school/ChoosePlanSchool.vue